import {Component} from '@angular/core';

@Component({
    selector: 'qa-deactivate-user-complete',
    templateUrl: './deactivate-user-complete.component.html',
    styleUrls: ['./deactivate-user-complete.component.scss'],
    standalone: false
})
export class DeactivateUserCompleteComponent {

  constructor() { }

}
